module.exports = __webpack_public_path__ + "public/img/mengolah dokumen dengan ms. word & ms. excel.252ff117.png";